import variables from '../variables';

const MuiInputLabel = {
  styleOverrides: {
    root: {
      overflow: 'auto',
      whiteSpace: 'normal',
      fontSize: variables.typography.body1.fontSize,
    },
  },
};

export default MuiInputLabel;
